import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/app/[slug]/ArticlePageClient.tsx");
